<script>
//定义公共属性

var it1024imURL = '.'
var it1024imLogin = it1024imURL + '/php/login.php'
var it1024imUrl =  it1024imURL + '/php/it1024im.php'

export default{
	it1024imURL,
	it1024imLogin,
	it1024imUrl
}

</script>


// WEBPACK FOOTER //
// src/common/common.vue